import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-modal-bootstrap";

import "./style.scss";

const OrderSuccessModal = ({
  orderInfo,
  hideModal,
  handleSurveyClick,
  surveyHref,
  handleTryAgain
}) => {

  const {
    communicationBlock = [],
    shipments = [],
    isError = false,
    message = "",
    orderId = "",
  } = orderInfo;

  return (
    <Modal isOpen={true} className="orderSuccessModal">
      {!isError && (
        <div className="header">
          <div>
            <p className="heading">Order Placed Sucessfully</p>
            <span>OrderId: {orderId}</span>
            <p className="subHeading">
              Payment Links will be sent to the customer after order is
              processed
            </p>
          </div>
          <img
            src={require("@images/order-success.svg")}
            alt="order-success-image"
          />
        </div>
      )}
      {isError ? (
        <div className="error">{message}</div>
      ) : (
        <div className="body">
          <div className="communication-container">
            {communicationBlock && communicationBlock.length>0 &&
              communicationBlock.map((communication, index) => (
                <div key={index} className="communication-block">
                  <img src={communication.imageUrl} alt="img" />
                  <div>
                    <p className="primary-text">
                      {communication.primaryLabel || ""}
                    </p>
                    <p className="secondary-text">
                      {communication.secondaryLabel || ""}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="shipment-container">
            <div className="heading">Delivery Details</div>
            <div className="shipments">
              {shipments && shipments.length &&
                shipments.map((shipment, index) => (
                  <div className="shipment" key={index}>
                    <div className="header">
                      <div className="header-1">
                        <span className="shipment-count">{`SHIPMENT ${
                          index + 1
                        }`}</span>
                        {shipment.price && shipment.price.savingAmount && (
                          <span className="savings">
                            SAVINGS {shipment.price.savingAmount}
                          </span>
                        )}
                      </div>
                      <div className="header-2">
                        <span>{shipment.eddDetails.text}</span> &nbsp;
                        <strong>{shipment.eddDetails.time}</strong>
                      </div>
                    </div>
                    <div className="content">
                      {!!shipment.items.length &&
                        shipment.items.map((item) => (
                          <div className="product-card" key={item.ucode}>
                            <div>{item.name}</div>
                            <strong className="quantity">
                              {item.quantity}
                            </strong>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      <div className="footer">
        <div className="serve-next" onClick={() => isError ? handleTryAgain(orderInfo) : hideModal()}>
          {isError ? 'Try Again' : 'Serve Next order'}
        </div>
        {!isError && (
          <a
            className="take-survey"
            rel="noopener noreferrer"
            target="_blank"
            onClick={handleSurveyClick}
            href={surveyHref}
          >
            Take Survey
          </a>
        )}
      </div>
    </Modal>
  );
};

OrderSuccessModal.proppTypes = {
  orderInfo: PropTypes.object.isRequired,
  hideModal: PropTypes.func.isRequired,
  handleSurveyClick: PropTypes.func.isRequired,
  surveyHref: PropTypes.string.isRequired,
  handleTryAgain: PropTypes.func.isRequired,
};

export default OrderSuccessModal;
